<template>
  <v-container
    fill-height
    justify-content-start
    class="app-section-width pa-0"
  >
    <v-layout
      v-if="loading"
      class="pa-4"
    >
      <v-row
        class="fill-height"
        align="center"
        justify="center"
      >
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
    </v-layout>

    <v-layout v-else column>
      <v-layout column class="flex-none">
        <div
          flat
          class="details-header"
          :style="{
            'background-image':
              'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(' +
              extendedActivity.activity.coverImageUrl +
              ')',
          }"
        >
          <v-layout mt-2>
            <div class="details-title pa-1">
              <v-icon
                @click="$router.go(-1)"
                color="white"
                class="ms-3"
                >mdi-arrow-left</v-icon
              >
              <v-toolbar-title class="ms-3 pr-2">{{
                pageName
              }}</v-toolbar-title>
            </div>
          </v-layout>
        </div>
      </v-layout>

      <reservation-type-chip :reservationMethodType="reservation.type" />

      <v-layout
        class="pa-2 mt-3"
        column
      >
        <activity-payment-methods class="full-height"/>
        
        <v-btn
          :disabled="!paymentServiceId"
          @click="retryPayment()"
          block
          outlined
          color="primary"
          class="primary-gradient"
        >
          {{ $t('activity_reservation.actions.confirm') }}
        </v-btn>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { ActivityReservationsRequests } from '@/services/activityReservations.requests'
import routeNames from '@/router/routes'
import { activityReservationStatus } from '@/config'

const activityReservationsService = new ActivityReservationsRequests()

export default {
  name: 'PaymentMethods',

  data () {
    return {
      loading: false,
      reservation: null,
    }
  },
  

  components: {
    ActivityPaymentMethods: () => import('@/components/view-components/activities/ActivityPaymentMethods.vue'),
    ReservationTypeChip: () => import('@/components/view-components/reservations/ReservationTypeChip.vue'),
  },

  computed: {
    ...mapGetters({
      pageName: 'pages/pageName',
    }),
    ...mapState({
      paymentServiceId: state => state.activityReservations.edited.paymentServiceId,
      extendedActivity: state => state.activities.extendedActivity,
    }),
  },

  methods: {
    retryPayment () {
      const params = {
        activityReservationId: this.$route.params.activityReservationId,
        paymentServiceId: this.paymentServiceId !== 'roomCharge' ? this.paymentServiceId : null,
      }

      activityReservationsService.retryPayment(params.activityReservationId, params.paymentServiceId)
        .then((data) => {
          if (data.redirectUrl) {
            this.$router.replace({ name: routeNames.reservationPayment.name, params: { redirectUrl: data.redirectUrl, ...params } })
          } else {
            this.$router.push({ name: routeNames.reservationComplete.name, params: { activityId: this.extendedActivity.activity.id, activityReservationId: params.activityReservationId } })
          }
        })
        .catch((error) => {
          this.$store.commit('state/setError', error)
          this.$router.replace({ name: routeNames.reservationError.name, params: { activityId: this.extendedActivity.activity.id, reservationMethod: this.reservationMethod } })
        })
    },
  },

  created () {
    this.loading = true

    activityReservationsService
      .getReservation(this.$route.params.activityReservationId)
      .then((response) => {
        this.reservation = response.reservation
        if (this.reservation.status === activityReservationStatus.PENDING_PAYMENT) {
          this.$store.dispatch('activities/getActivity', { id: response.activity.id })
            .then((response) => {
              this.$store.commit('activityReservations/setField', {
                field: 'paymentServiceId',
                value: null,
              })
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$router.replace({ name: routeNames.activity_reservations.name, query: { reservationId: this.$route.params.activityReservationId} })
        }
      }).catch((error) => {
        this.$router.replace({ name: routeNames.activity_reservations.name })
      })
  },
}
</script>

<style>
</style>
